export const RESOURCE = {
  SERVICE_NAME: '작가의 시작',
  DOMAIN: 'debut',

  ARTIST_APPLY_BUTTON_TEXT: '작가 입점 신청하기',

  ARTIST_SERVICE_INTRODUCE_LINK: 'https://scout.idus.com/',
  ARTIST_SERVICE_GUIDE_LINK:
    'https://stibee.com/api/v1.0/emails/share/CZ6Lix0eC1lhVJ6AAATXUnqUPBF4ptk',

  HOME_LINK: {
    YOUTUBE:
      'https://www.youtube-nocookie.com/embed/aXhHvfEAVJE?si=vRJmaBw4DvpT-P7r&autoplay=1&playlist=aXhHvfEAVJE&loop=1&controls=0&disablekb=1&showinfo=0&rel=0&mute=1',
    ARTIST_STORY:
      'https://www.youtube.com/playlist?list=PLWSwF8VPrUWo270oyC7HEWa8EuG3X8Q7P',
    ARTIST_AND_CUSTOMER:
      'https://www.youtube.com/watch?v=ITfzrAlpQHA&list=PLWSwF8VPrUWoGneZWPXpf8yqzq7Pm-e5S&ab_channel=%EC%95%84%EC%9D%B4%EB%94%94%EC%96%B4%EC%8A%A4%28idus%29',
    IDUS_GLOBAL:
      'https://idus.notion.site/idus-1ec1f5a713448031951fe04e8c9e9cfe',
    TUMBLBUG: 'https://tumblbug.com',
    IDUS: 'https://www.idus.com',
    SMART_STORE: 'https://smartstore.naver.com/idus',
    STUDIO: 'https://cnn.idus.com/board/notice-artist/post/432',
    EDU: 'https://idus.notion.site/idus-07646b6a91504513a231ef01d2358c4c',
    SERVICE: 'https://cnn.idus.com/board/notice-artist/post/1055',
  },

  META: {
    DESCRIPTION: '아이디어스 작가 입점 서비스',
    IDUS_KEYWORD: [
      '핸드메이드',
      '수공예',
      '디저트',
      '선물',
      '폰케이스',
      '목걸이',
      '귀걸이',
      '반지',
    ],
    LOCALE: 'ko-KR',
  },

  JOIN: {
    EMAIL_CERTIFY_CODE_LIMIT: 10 * 60 * 1000, // 10분
    EMAIL_VERIFICATION_CODE_LENGTH: 6,
  },
}
